<template>
  <v-navigation-drawer
    class="drawer-nav"
    dark
    fixed
    permanent
    expand-on-hover
    d-none
    d-md-flex
    d-lg-none
    v-if="showNav"
  >
    <v-list>
      <v-list-item class="px-2, avatar-container">
        <v-list-item-content>
          <div>
            <v-list-item-avatar
              color="teal"
              class="white--text headline, user-avatar"
              wrap
            >{{ userAvatar }}</v-list-item-avatar>
          </div>
        </v-list-item-content>

        <v-list-item-content>
          <v-list-item-title class="title-2">{{ userName }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>

    <!-- Options -->
    <v-list nav dense bounded>
      <v-list-group color="white" prepend-icon="mdi-bell">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Notificaciones</v-list-item-title>
          </v-list-item-content>
        </template>

        <!-- Notificaciones -->
        <v-list-item v-for="subItem in items" :key="subItem.id">
          <v-list-item-content>
            <v-list-item-title>Invitación pendiente: {{subItem.name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- Notificaciones -->
        <v-list-item v-if="items.length==0">
          <v-list-item-content>
            <v-list-item-title>No tiene notificaciones.</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-for="(link, i) in links"
        :key="i"
        :to="link.to"
        class="v-list-item"
        @click="logout(link.text)"
        link
      >
        <v-list-item-icon>
          <v-icon>{{ link.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title v-text="link.text" />
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import * as firebase from "firebase";
import { mapGetters, mapActions } from "vuex";
// import { mapMutations, mapGetters } from "vuex";

export default {
  data: () => ({
    showNav: false,
    userName: "",
    userAvatar: "",
    items: [],
    links: [
      {
        to: "/projects",
        icon: "mdi-view-dashboard",
        text: "Proyectos"
      },
      {
        to: "/user-profile",
        icon: "mdi-account",
        text: "Perfil de Usuario"
      },
      {
        to: "/projectcreate",
        icon: "mdi-book-plus",
        text: "Creacion de Proyecto"
      },
      {
        to: "/",
        icon: "mdi-logout",
        text: "Cerrar Sesión"
      }
    ]
  }),

  mounted() {
    const user = firebase.auth().currentUser;

    if (user !== null) {
      const idUser = firebase.auth().currentUser.uid;
      this.showNav = true;
      this.userName = user.displayName;
      var avatar = user.displayName.split(" ");
      this.userAvatar = avatar[0].charAt(0) + avatar[1].charAt(0);

      this.items = this.getPendingProjects;
      if (!this.items || this.items.length === 0) {
        this.items = [];
        firebase
          .firestore()
          .collection("User")
          .doc(idUser)
          .get()
          .then(result => {
            const data = result.data();

            data.projectsPending.forEach(pj =>
              this.items.push({
                ...pj,
                showed: true
              })
            );
          });
      }
    }
  },

  computed: {
    ...mapGetters("projects", ["getPendingProjects"]),
    userLogedIn() {
      return this.$store.getters.user;
    }
  },

  methods: {
    ...mapActions("projects", ["cleanNotification"]),
    // ...mapMutations(["login", "insertSession"]),
    logout(text) {
      if (text === "Cerrar Sesión") {


        
        // var currentUser = firebase.auth().currentUser;

        this.$store.dispatch("user/logout");
        // eslint-disabe-next-line no-console
        // firebase
        //   .auth()
        //   .signOut()
        //   .then(() => {
        //     window.localStorage.clear();
        //     this.cleanNotification();
        //     this.$router.push({ name: "init" });
        //     // eslint-disable-next-line no-console
        //     console.log("Gracias por usar INEDITA");
        //   })
        //   .catch(error => {
        //     // eslint-disable-next-line no-console
        //     console.log("A problem with logout the user: " + error);
        //   });

        this.$router.push({ name: "init" });
        // eslint-disable-next-line no-console
        console.log("Gracias por usar INEDITA");
      }
    }
  },

  props: {
    opened: {
      // displayName:"",
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
@media handheld, only screen and (max-width: 949px) {
  .drawer-nav {
    display: none;
  }
}

.avatar-container {
  margin-right: 5px;
  display: inline-block;
  padding: inherit;
  margin-left: 10px;
  align-content: center;

  .avatar-wrapper {
    margin-top: 5px;
    margin-right: 5px;
    margin-left: 5px;
    position: relative;

    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
    }
  }
}
</style>
